import React from "react";
import { connect } from "react-redux";
import CommunitySolar from "../components/CommunitySolar";
import selectCommunitySolarsContainer from "../selectors/communitySolar";
import {
  getApprovals,
  getDetails,
  updateMeter,
  openMemberDocument,
  getCSEnrollments,
} from "../actions/communitySolar";
import { fetchEnrollmentByMemberId, refreshMemberProduct } from "../actions/search";
import { csmeterBodyUpdate } from "../actions/members";
import { requestTdsps } from "../actions/lookup";

const CommunitySolarContainer = (props) => <CommunitySolar {...props} />;

const mapStateToProps = (state) => ({
  ...selectCommunitySolarsContainer(state)(state),
  adminUser: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  doFetchGetApprovals: (page) => {
    dispatch(getApprovals({ page, limit: 100 }));
  },
  doFetchGetDetails: memberID => {
    dispatch(getDetails(memberID));
  },
  doFetchUpdateMeter: payload => {
    dispatch(updateMeter(payload));
  },
  doOpenDocument: (memberID, documentID) => {
    dispatch(openMemberDocument(memberID, documentID));
  },
  doFetchEnrollments: (status, page) => {
    dispatch(getCSEnrollments({ status, page, limit: 100 }));
  },
  doFetchMemberEnrollment: (memberID) => {
    dispatch(fetchEnrollmentByMemberId(memberID));
  },
  doRefreshMemberProduct: (memberID) => {
    dispatch(refreshMemberProduct(memberID));
  },
  doFetchRequestTdsps: () => {
    dispatch(requestTdsps());
  },
  doCSMeterBodyUpdate: (meterID, body, memberID) =>
    dispatch(csmeterBodyUpdate(meterID, body, memberID)),
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(CommunitySolarContainer);
